import { z } from 'zod';

import { createEntityAdapterSchema } from '../../base';
import { TestCaseSchema } from './testing.schema';

export const TestingStateSchema = z
  .object({
    testCases: createEntityAdapterSchema(TestCaseSchema),
  })
  .describe(
    'Testing domain state - Contains test cases with tags for categorization and filtering.',
  );

export type TestingState = z.infer<typeof TestingStateSchema>;
